import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c(VIcon,{attrs:{"small":""}},[_vm._v("person")]),_vm._v(_vm._s(_vm.data[_vm.dataKey]))],1)}
var staticRenderFns = []

export { render, staticRenderFns }